import React from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './PaymentCancellation.css';

const PaymentCancellation = () => {
  const { orderId } = useParams();
  const [searchParams] = useSearchParams();
  const hdfcOrderId = searchParams.get('hdfc_order_id') || searchParams.get('order_id');
  const status = searchParams.get('status') || 'cancelled';

  return (
    <div className="App">
      <Header />
      <div className="payment-cancellation-page">
        <div className="container">
          <div className="cancellation-content">
            {/* Cancellation Icon */}
            <div className="cancellation-icon-wrapper">
              <div className="cancellation-icon">
                <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="15" y1="9" x2="9" y2="15"></line>
                  <line x1="9" y1="9" x2="15" y2="15"></line>
                </svg>
              </div>
            </div>

            {/* Title */}
            <h1 className="cancellation-title">Payment Cancelled</h1>
            
            {/* Message */}
            <div className="cancellation-message">
              <p>Your payment transaction has been cancelled.</p>
              <p className="sub-message">
                No amount has been deducted from your account. Your order is still pending payment.
              </p>
            </div>

            {/* Order Info */}
            {orderId && (
              <div className="order-info-box">
                <div className="info-item">
                  <span className="info-label">Order ID:</span>
                  <span className="info-value">#{orderId}</span>
                </div>
                {hdfcOrderId && (
                  <div className="info-item">
                    <span className="info-label">Transaction ID:</span>
                    <span className="info-value">{hdfcOrderId}</span>
                  </div>
                )}
              </div>
            )}

            {/* Action Buttons */}
            <div className="cancellation-actions">
              {orderId && (
                <Link to={`/order-confirmation/${orderId}`} className="btn-view-order">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                    <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                  </svg>
                  <span>View Order Details</span>
                </Link>
              )}
              <Link to="/checkout" className="btn-retry-payment">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M23 4v6h-6"></path>
                  <path d="M1 20v-6h6"></path>
                  <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
                </svg>
                <span>Retry Payment</span>
              </Link>
              <Link to="/cart" className="btn-back-to-cart">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M19 12H5"></path>
                  <path d="M12 19l-7-7 7-7"></path>
                </svg>
                <span>Back to Cart</span>
              </Link>
            </div>

            {/* Help Text */}
            <div className="help-text">
              <p>
                If you need assistance or have any questions, please{' '}
                <Link to="/contact">contact our support team</Link>.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PaymentCancellation;

